import { gql, useMutation } from '@apollo/client';

import { ONBOARDING_FAMILY_FRAGMENT } from '../queries/useOnboardingState';

import type {
  CreateDependantAndRelationshipMutation,
  CreateDependantAndRelationshipMutationVariables,
} from './__generated__/useCreateDependantAndRelationship.gql';

const CREATE_DEPENDANT_AND_RELATIONSHIP = gql`
  mutation CreateDependantAndRelationship($input: CreateDependantAndRelationshipInput!) {
    createDependantAndRelationship(input: $input) {
      ...OnboardingFamilyFragment
    }
  }
  ${ONBOARDING_FAMILY_FRAGMENT}
`;

/**
 * Creates a `Dependant` row and the caregiver edge from the acting user.
 * Returns the parent `Family` with its updated caregiver-relationship list
 * so Apollo's normalized cache updates `GetOnboardingState` and
 * `GetDependants` automatically — no `refetchQueries` or manual
 * refetch needed at the call site.
 */
export const useCreateDependantAndRelationship = () => {
  return useMutation<CreateDependantAndRelationshipMutation, CreateDependantAndRelationshipMutationVariables>(
    CREATE_DEPENDANT_AND_RELATIONSHIP
  );
};
